import React from 'react'

import clsx from 'clsx'
import moment from 'moment-jalaali'
import { useSelector } from 'react-redux'
import { VisaStatus } from 'src/components/VisaStatus/VisaStatus'
import { VisaItemType } from 'src/types'
import { CrewVisaOperations } from './CrewVisaOperations'
import { useTranslation } from 'react-i18next'

export const VisaOrderRow = (record: VisaItemType & { onSuccessMutate: Function }) => {

    const { subject, automation_number, created_at, agent, id, visa, crews ,onSuccessMutate } = record


    const user = useSelector((state) => (state as any).user.user)

    const lng = useSelector((state) => (state as any).common.lng)

    const isAgent = user?.role_key === "agent"

    const isAdmin = user?.role_key === "super_admin"

    const { t } = useTranslation()

    if (crews.filter(i=>!!i.crew).length != 0) {

        const { job, visa_job , crew, visa: { status }, agent_visa_id, crew_id } = crews?.[0]

        return (
            <div className='border rounded-xl border-gray-400  flex flex-col  gap-2 mx-4 p-2 '>

                <div key={id} className={` grid  items-center w -full    grid-cols-8`} >



                    <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {id}
                        </div>
                    </div>
                    {/*<div className="p-3 text-center">*/}
                    {/*  <div className={"text-gray-500 text-sm mt-1"}>*/}
                    {/*    {item?.crew?.nationality}*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                    <div className="p-3 text-center col-span-1">
                        <div className={"text-primary-400 text-sm mt-1 "}>
                            {(visa as any)?.[`${lng}_name`]}
                        </div>
                    </div>
                    {!isAgent && <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {(agent?.name ?? '-') + " " + (agent?.last_name ?? '-')}
                        </div>
                    </div>}
                    <div className="p-3 text-center col-span-1">
                        <div className={clsx("text-gray-500 text-sm mt-1", crews.length > 1 && 'text-red')}>
                            {crew?.name ?? '-'}{crew?.last_name} {crews.length > 1 && <span className='' dir='ltr'>/ {(crews.length)} Crews /</span>}
                        </div>
                    </div>

                    <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {visa_job?.[0]?.name ?? '-'}
                        </div>
                    </div>

                    <div className="p-3 text-center col-span-1">
                        <div className={"text-gray-500 text-sm mt-1"}>
                            {created_at && moment(created_at).format(lng === "en" ? "YYYY/MM/DD" : "jYYYY/jMM/jDD")}
                        </div>
                    </div>



                    <div className=" py-4 text-start text-gray-500 text-sm font-medium col-span-1">
                        <div className={"mt-1 flex justify-center"}>
                            <VisaStatus status={status} />
                        </div>
                    </div>
                    {/*<div className=" py-4  text-start text-gray-500 text-sm font-medium col-span-1">
          {
              
              <div className={"flex justify-center" }>
              <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
              {!(status === 0 || status === 1) ? <FormIconPure/> : <FormIcon/>}
              </div>
              </div>
            }
            
        </div> */}
                    <div className={clsx("p-3 text-center col-span-1 flex flex-row gap-2 items-center ", isAgent ? 'justify-between' : 'justify-center')}>
                        {
                            // (user?.role_key === "agent" || !!automation_number) ?
                            <div className={"text-gray-500 text-sm mt-1 flex-1 text-center "}>
                                <div className={"flex gap-2 justify-center"}>
                                    <span>{automation_number ?? '-'}</span>
                                </div>
                            </div>
                            // :
                            // <div className={"text-gray-500 text-sm mt-1"}>
                            //     <div className={"flex gap-2 justify-center"}>
                            //         <span className={"w-[120px]"}>
                            //             <CustomInput
                            //                 placeHolder={t("automationNumber")}
                            //                 label={t("automationNumber")}
                            //                 name={"automationNumber" + id}
                            //                 onchange={(e: any) => setAtNumber(e?.value)}
                            //                 defaultValue={atNumber}
                            //                 disable={isLoadingProccess}
                            //             />
                            //         </span>
                            //         <div className={"w-[80px]"} onClick={(e) => e.stopPropagation()}>
                            //             {isLoadingProccess
                            //                 ? <div className='flex flex-row flex-1 justify-center items-center h-full'><Loading /></div>
                            //                 : <CustomButton

                            //                     onClick={() => {
                            //                         if (!atNumber) {
                            //                             return toast.info(t('automationNumberIsNotEntered'))
                            //                         }
                            //                         setSelected(true)
                            //                         // setId(item.id)
                            //                     }} styles={"text-sm"} title={t("save")} />}
                            //         </div>
                            //     </div>
                            // </div>
                        }

                        {/* <ChevronDown className={`transition-all duration-300 size-4 text-gray-700 shrink-0 ${isOpen ? '-rotate-180' : ''}`} /> */}
                    </div>

                    {isAgent && <div className=" py-4 text-start text-gray-500 bg-transparent text-sm font-medium col-span-1 flex flex-row justify-center overflow-visible">
                        <CrewVisaOperations isResidence={!!visa?.residence} onSuccessMutate={onSuccessMutate} agentVisaId={agent_visa_id} crewData={crews?.[0]} />
                    </div>}

                </div>
            </div>

            // </div >
        )

    }
    return <div className='border rounded-xl border-gray-400  flex flex-col  gap-2 mx-4 p-2 overflow-hidden text-center text-sm text-gray-500'> {t('visa')} ID = {id} {t('CrewIsEmpty')}</div>
}
